// import React, { useMemo } from 'react';
// import { ClockIcon, XMarkIcon } from '@heroicons/react/24/outline';
// import { OrderDetail, DailyProgress } from '../store/OrderStore';

// interface GroupWorkProgressModalProps {
//     isOpen: boolean;
//     onClose: () => void;
//     group: {
//         _id: string;
//         fullName: string;
//     };
//     orderDetails: OrderDetail[];
// }

// // Ek helper type
// interface FlattenedProgress {
//     sizeName: string;
//     totalPieces: number;
//     progress: DailyProgress;
// }

// const GroupWorkProgressModal: React.FC<GroupWorkProgressModalProps> = ({ isOpen, onClose, group, orderDetails }) => {
 

//     // Is logic se hum sirf is group ke saare tasks ko nikalenge
//     const allProgressForGroup = useMemo(() => {
//         const flattened: FlattenedProgress[] = [];
//         orderDetails.forEach(detail => {
//             const groupAssignment = detail.groupWorkAssignments?.find(
//                 (ga: any) => ga.groupWorkId?._id === group._id
//             );

//             if (groupAssignment && groupAssignment.dailyProgress) {
//                 groupAssignment.dailyProgress.forEach(progress => {
//                     flattened.push({
//                         sizeName: detail.sizeSegmentId.segmentName,
//                         totalPieces: detail.totalPieces,
//                         progress: progress,
//                     });
//                 });
//             }
//         });
//         return flattened;
//     }, [orderDetails, group._id]);

//        if (!isOpen) return null;

//     return (
//         <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
//             <div className="bg-white rounded-2xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
//                 <div className="flex justify-between items-center p-6 border-b border-gray-200">
//                     <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-3">
//                         <ClockIcon className="w-7 h-7 text-indigo-600" />
//                         Progress for: {group.fullName}
//                     </h2>
//                     <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100">
//                         <XMarkIcon className="w-6 h-6 text-gray-500" />
//                     </button>
//                 </div>

//                 <div className="overflow-y-auto p-6">
//                     {allProgressForGroup.length > 0 ? (
//                         <table className="w-full text-sm">
//                             <thead className="text-left bg-gray-50">
//                                 <tr className="border-b-2 border-gray-200">
//                                     <th className="p-4 font-semibold text-gray-600">Size</th>
//                                     <th className="p-4 font-semibold text-gray-600">Member</th>
//                                     <th className="p-4 font-semibold text-gray-600">Pieces Claimed</th>
//                                     <th className="p-4 font-semibold text-gray-600">Status</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {allProgressForGroup.map((item, index) => (
//                                     <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
//                                         <td className="p-4 font-medium text-gray-800">{item.sizeName}</td>
//                                         <td className="p-4">{item.progress.memberName}</td>
//                                         <td className="p-4 font-bold text-indigo-700 text-base">{item.progress.piecesClaimed}</td>
//                                         <td className="p-4">
//                                             <span className={`px-3 py-1 text-xs font-semibold rounded-full ${
//                                                 item.progress.status === 'Completed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
//                                             }`}>
//                                                 {item.progress.status}
//                                             </span>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     ) : (
//                         <p className="text-center text-gray-500 py-10">No progress has been logged by this group for the assigned tasks yet.</p>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default GroupWorkProgressModal;
import React, { useMemo } from 'react';
import { ClockIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { OrderDetail, DailyProgress } from '../store/OrderStore';

interface GroupWorkProgressModalProps {
    isOpen: boolean;
    onClose: () => void;
    group: {
        _id: string;
        fullName: string;
    };
    orderDetails: OrderDetail[];
}

interface SizeProgressSummary {
    sizeName: string;
    totalPieces: number;
    totalClaimed: number;
    totalCompleted: number;
    remainingPieces: number;
    claims: DailyProgress[];
}

const GroupWorkProgressModal: React.FC<GroupWorkProgressModalProps> = ({ isOpen, onClose, group, orderDetails }) => {
    
    const progressSummary = useMemo(() => {
        const summary: SizeProgressSummary[] = [];

        orderDetails.forEach(detail => {
            const groupAssignment = detail.groupWorkAssignments?.find(
                (ga: any) => ga.groupWorkId?._id === group._id
            );

            if (groupAssignment && groupAssignment.dailyProgress && groupAssignment.dailyProgress.length > 0) {
                let totalClaimed = 0;
                let totalCompleted = 0;

                groupAssignment.dailyProgress.forEach(progress => {
                    totalClaimed += progress.piecesClaimed;
                    if (progress.status === 'Completed') {
                        totalCompleted += progress.piecesClaimed;
                    }
                });

                summary.push({
                    sizeName: detail.sizeSegmentId.segmentName,
                    totalPieces: detail.totalPieces,
                    totalClaimed: totalClaimed,
                    totalCompleted: totalCompleted,
                    remainingPieces: detail.totalPieces - totalClaimed,
                    claims: groupAssignment.dailyProgress,
                });
            }
        });
        return summary;
    }, [orderDetails, group._id]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50 p-2 sm:p-4">
            <div className="bg-white rounded-xl sm:rounded-2xl shadow-2xl w-full max-w-7xl max-h-[95vh] sm:max-h-[92vh] flex flex-col overflow-hidden">
                {/* Header */}
                <div className="flex justify-between items-center px-4 py-4 sm:px-6 sm:py-5 bg-blue-600 text-white">
                    <h2 className="text-base sm:text-xl md:text-2xl font-bold flex items-center gap-2 sm:gap-3">
                        <ClockIcon className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 flex-shrink-0" />
                        <span className="truncate">Progress for: {group.fullName}</span>
                    </h2>
                    <button 
                        onClick={onClose} 
                        className="p-1.5 sm:p-2 rounded-full hover:bg-white/20 transition-all duration-200 active:scale-95 flex-shrink-0"
                    >
                        <XMarkIcon className="w-5 h-5 sm:w-6 sm:h-6" />
                    </button>
                </div>

                {/* Content */}
                <div className="overflow-y-auto p-3 sm:p-6 md:p-8 bg-gray-50">
                    {progressSummary.length > 0 ? (
                        <>
                            {/* Desktop & Tablet View - Table */}
                            <div className="hidden md:block bg-white rounded-lg sm:rounded-xl shadow-lg border border-gray-200 overflow-hidden">
                                <div className="overflow-x-auto">
                                    <table className="w-full text-xs sm:text-sm">
                                        <thead className="text-left bg-gray-100">
                                            <tr className="border-b-2 border-gray-300">
                                                <th className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-gray-700 whitespace-nowrap">Size</th>
                                                <th className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-gray-700 whitespace-nowrap">Total Pieces</th>
                                                <th className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-gray-700 whitespace-nowrap">Claimed</th>
                                                <th className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-gray-700 whitespace-nowrap">Completed</th>
                                                <th className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-gray-700 whitespace-nowrap">Remaining</th>
                                                <th className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-gray-700 whitespace-nowrap">Member</th>
                                                <th className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-gray-700 whitespace-nowrap">Pieces Claimed</th>
                                                <th className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-gray-700 whitespace-nowrap">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-400">
                                            {progressSummary.map((summary) => (
                                                <React.Fragment key={summary.sizeName}>
                                                    {summary.claims.map((claim, claimIndex) => (
                                                        <tr 
                                                            key={claim._id} 
                                                            className="hover:bg-blue-50 transition-colors duration-150"
                                                        >
                                                            {claimIndex === 0 ? (
                                                                <>
                                                                    <td className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-gray-900 text-sm sm:text-base" rowSpan={summary.claims.length}>
                                                                        {summary.sizeName}
                                                                    </td>
                                                                    <td className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-gray-800 text-sm sm:text-base" rowSpan={summary.claims.length}>
                                                                        {summary.totalPieces}
                                                                    </td>
                                                                    <td className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-blue-700 text-sm sm:text-base" rowSpan={summary.claims.length}>
                                                                        {summary.totalClaimed}
                                                                    </td>
                                                                    <td className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-blue-700 text-sm sm:text-base" rowSpan={summary.claims.length}>
                                                                        {summary.totalCompleted}
                                                                    </td>
                                                                    <td className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-gray-700 text-sm sm:text-base" rowSpan={summary.claims.length}>
                                                                        {summary.remainingPieces}
                                                                    </td>
                                                                </>
                                                            ) : null}
                                                            <td className="px-3 py-3 sm:px-4 sm:py-3.5 text-gray-700 font-medium">{claim.memberName}</td>
                                                            <td className="px-3 py-3 sm:px-4 sm:py-3.5 font-semibold text-blue-700 text-sm sm:text-base">{claim.piecesClaimed}</td>
                                                            <td className="px-3 py-3 sm:px-4 sm:py-3.5">
                                                                <span className={`inline-flex items-center px-2.5 py-1 sm:px-3 sm:py-1.5 text-xs font-semibold rounded-full ${
                                                                    claim.status === 'Completed' 
                                                                        ? 'bg-blue-100 text-blue-800' 
                                                                        : 'bg-gray-100 text-gray-700'
                                                                }`}>
                                                                    {claim.status}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Mobile View - Cards */}
                            <div className="md:hidden space-y-4">
                                {progressSummary.map((summary) => (
                                    <div key={summary.sizeName} className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
                                        {/* Size Summary Header */}
                                        <div className="bg-blue-600 text-white px-4 py-3">
                                            <h3 className="text-base font-bold mb-2">{summary.sizeName}</h3>
                                            <div className="grid grid-cols-2 gap-2 text-xs">
                                                <div>
                                                    <span className="opacity-90">Total:</span>
                                                    <span className="ml-1 font-semibold">{summary.totalPieces}</span>
                                                </div>
                                                <div>
                                                    <span className="opacity-90">Claimed:</span>
                                                    <span className="ml-1 font-semibold">{summary.totalClaimed}</span>
                                                </div>
                                                <div>
                                                    <span className="opacity-90">Completed:</span>
                                                    <span className="ml-1 font-semibold">{summary.totalCompleted}</span>
                                                </div>
                                                <div>
                                                    <span className="opacity-90">Remaining:</span>
                                                    <span className="ml-1 font-semibold">{summary.remainingPieces}</span>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {/* Claims List */}
                                        <div className="divide-y divide-gray-200">
                                            {summary.claims.map((claim) => (
                                                <div key={claim._id} className="p-4 hover:bg-gray-50 transition-colors">
                                                    <div className="flex justify-between items-start mb-2">
                                                        <div className="flex-1">
                                                            <p className="text-sm font-semibold text-gray-900">{claim.memberName}</p>
                                                            <p className="text-xs text-gray-600 mt-0.5">
                                                                Pieces: <span className="font-semibold text-blue-700">{claim.piecesClaimed}</span>
                                                            </p>
                                                        </div>
                                                        <span className={`inline-flex items-center px-2.5 py-1 text-xs font-semibold rounded-full ${
                                                            claim.status === 'Completed' 
                                                                ? 'bg-blue-100 text-blue-800' 
                                                                : 'bg-gray-100 text-gray-700'
                                                        }`}>
                                                            {claim.status}
                                                        </span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <div className="bg-white rounded-lg sm:rounded-xl shadow-lg border border-gray-200 p-8 sm:p-12 md:p-16">
                            <p className="text-center text-gray-500 text-sm sm:text-base">
                                No progress has been logged by this group for the assigned tasks yet.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default GroupWorkProgressModal;
